import axios from 'axios'
import { Toast, Dialog } from 'vant'
var token = localStorage.getItem('token')
var uid = localStorage.getItem('uid')
var loading = null;
var Http = {
	request( {url, data = {}, showLoading = true, method = 'POST'} ){
		return new Promise( (yes, no) => {
			if(showLoading){
				loading = Toast.loading({
					message: '加载中',
					duration: 0,
					forbidClick: true
				})
			}
			
			var format = method.toLocaleLowerCase() === 'get' ? 'params' : 'data';
			axios({
				url: url,
				method: method,
				[format]: data,
				headers: {
					"token": token,
					"uid": uid,
					"Content-type": "application/json"
				}
			}).then( res => {
				showLoading && loading.clear()
				if(res.data.status === -1){
					localStorage.setItem('now_url', location.href)
					// Toast.fail(res.data.message)
					// window.location.href = '/auth-center'
					Dialog.alert({
						title: '提示',
						message: '为了更好的提供服务\n请先登录账号',
						confirmButtonText: '去登录'
					}).then( () => {
						window.location.href = '/auth-center'
					} );
					return
				}
				if(res.data.status === -2){
					Toast.fail(res.data.message)
				}
				if(res.data.status === -1000){
					Dialog.confirm({
						title: '提示',
						message: res.data.message,
						confirmButtonText: '我要开通',
						cancelButtonText: '下次'
					}).then( () => {
						window.location.href = '/center-buy'
					} ).catch( () => {} )
					return
				}
				yes(res.data)
			} ).catch( (err) => {
				showLoading && loading.clear()
				no(err)
				Toast.fail('发生错误')
			} )
		} )
	}
}

export {
	Http
}